import React, { memo, useCallback } from "react";
import { EditSideBar } from "./EditSideBar";
import { ReactComponent as ArrowIcon } from "../../assets/icons/accordion.svg";

export const Accordion = memo(
  ({
    title,
    links,
    icon,
    getCurrentComponent,
    stepIndex,
    currentAccordion,
    isActive,
    onClick,
  }) => {

    const handleKeyDown = useCallback(
      (e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          onClick?.();
        }
      },
      [onClick]
    );

    const handleAccordionClick = () => {
      onClick?.();
    };

    return (
      <div
        className={`rounded mb-2 transition-all duration-200 ${
          isActive ? "border-primary shadow-md" : "border-gray-200"
        }`}
      >

        {/* HEADER */}
        <div
          className="flex items-center justify-start gap-2 p-3 cursor-pointer select-none text-f14 font-semibold text-primary hover:bg-gray-50 transition-all duration-200"
          role="button"
          tabIndex={0}
          aria-expanded={isActive}
          onClick={handleAccordionClick}
          onKeyDown={handleKeyDown}
        >

          <span className="flex items-center justify-center w-5 h-5">
            {icon}
          </span>

          <span className="truncate">{title}</span>

          <div
            className={`ml-auto transform transition-transform duration-300 ${
              isActive ? "rotate-180" : "rotate-0"
            }`}
          >
            <ArrowIcon />
          </div>

        </div>

        {/* BODY */}
        <div
          className={`transition-all duration-300 overflow-hidden ${
            isActive ? "max-h-[600px] opacity-100" : "max-h-0 opacity-0"
          }`}
        >
          {isActive && (
            <div className="p-3 bg-white text-left">

              <EditSideBar
                steps={links}
                getCurrentComponent={getCurrentComponent}
                stepIndex={stepIndex}
                currentAccordion={currentAccordion}
              />

            </div>
          )}
        </div>

      </div>
    );
  }
);

export default Accordion;
